// app/javascript/quotes/components/App.jsx
import React from 'react'

import AuthStore from 'stores/AuthStore'


class SubscriberWrapper extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoggedIn: AuthStore.isLoggedIn()
    }

    this._onChange = this._onChange.bind(this);
  }

  _onChange () {
    this.setState({
      isLoggedIn: AuthStore.isLoggedIn()
    })
  }

  componentDidMount () {
    AuthStore.addChangeListener(this._onChange);
    this._onChange();
  }

  componentWillUnmount () {
    AuthStore.removeChangeListener(this._onChange);
  }

  render ()
  {
    return React.cloneElement(this.props.children, {
      ...this.props,
      isLoggedIn: this.state.isLoggedIn
    });
  }
}

export default SubscriberWrapper
